import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import Swal from 'sweetalert2';
import { DocumentoSol, GetSoporteRQ } from '../../Interfaces';
import { FDLMService } from '../../services/FDLM.Service';
import { AudioService } from '../../services/AudioService.service';

@Component({
  selector: 'app-diagsound',
  templateUrl: './diagsound.component.html',
  styleUrls: ['./diagsound.component.css']
})
export class DiagsoundComponent implements OnInit {
  [x: string]: any;
  public strNombredoc: string;
  //public audio: Audio;
  public NoClick: boolean = true;
  public strMensaje: string;

  constructor(private FDLMService: FDLMService,
    private AudioService: AudioService,
    public dialogRef: MatDialogRef<DiagsoundComponent>,
    @Inject(MAT_DIALOG_DATA) public parDocumento: DocumentoSol) { }

  Cerrar(): void {
    this.AudioService.stop();
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.NoClick = true;
    this.strNombredoc = this.parDocumento.StrTipoDocumento;
    this.strMensaje = "";

  }

  ReproAudio(): void {
    this.NoClick = false;
    this.strMensaje = "Cargando ...";
      var oGetSoporteRQ = <GetSoporteRQ>{
        parIdCabVer: this.parDocumento.tmpIdCabVer,
        parFormato: "WAV",
        parIdOrigen: 2 //2. Descarga Documento
      }

      //SE ENVIA A DESCARGAR EL ARCHIVO
      this.FDLMService.GetSoporte(oGetSoporteRQ).subscribe(
        async data => {

          if (data.type != "application/json") {
            let downloadedFile: Blob;
            downloadedFile = new Blob([data], { type: data.type });

            let arrayBuffer: ArrayBuffer;

            arrayBuffer = await downloadedFile.arrayBuffer();
            this.strMensaje = "";
            this.AudioService.playArray(arrayBuffer).subscribe(events => {
              
              // listening for fun here
            });
            //const audioCtx = new AudioContext();
            //const source = audioCtx.createBufferSource();
            //audioCtx.decodeAudioData(arrayBuffer, (buffer) => {
            //  source.buffer = buffer;
            //  source.connect(audioCtx.destination);
            //});

            //source.start();

          }
          else {
            console.log("error descargando archivo 2");
            Swal.fire({ text: 'Error descargando documento', icon: 'warning', confirmButtonText: "Aceptar" });
            this.NoClick = true;
          }
        },
        error => {
          console.log("error descargando archivo 2");
          Swal.fire({ text: 'Error descargando documento', icon: 'warning', confirmButtonText: "Aceptar" });
          this.NoClick = true;
        }
      );

  }

}
